import {Alert, List, Modal, Skeleton, Tag, Typography} from 'antd';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';

const {Text} = Typography;

const FinalProductLowStock = ({
  isModalOpen,
  setIsModalOpen,
  lowStockFinalProducts = [],
  isLoading,
}) => {
  const navigate = useNavigate();
  const handleClose = () => setIsModalOpen(false);

  return (
    <Modal
      title={'Low Stock Final Products'}
      open={isModalOpen}
      onOk={handleClose}
      onCancel={handleClose}
      width={850}
      Styles={{
        maxHeight: '500px',
        overflowY: 'auto',
        background: '#f8fafc',
      }}
    >
      {isLoading ? (
        <Skeleton active />
      ) : lowStockFinalProducts.length === 0 ? (
        <Alert
          type={'success'}
          message={'No final products are low in stock 🎉'}
          showIcon
        />
      ) : (
        <List
          dataSource={lowStockFinalProducts}
          renderItem={item => (
            <List.Item
              className={
                'group cursor-pointer rounded-2xl border border-primary-200 bg-white p-0 my-4 overflow-hidden transition-all duration-300 hover:shadow-lg hover:-translate-y-1'
              }
              onClick={() =>
                navigate('/admin/products', {
                  state: {
                    activeTab: '2',
                    openDetail: true,
                    productId: item.id,
                  },
                })
              }
            >
              <div className={'flex w-full p-5 justify-between items-center'}>

                <div>
                  <h3 className={'text-lg font-bold'}>
                    {item.productName}
                  </h3>

                  <p className={'text-sm text-gray-500'}>
            HSN : {item.hsnCode || '--'}
                  </p>
                </div>

                <Tag
                  color={item.quantity === 0 ? 'red' : 'orange'}
                  className={'rounded-full'}
                >
                  {item.quantity === 0 ? 'Out of Stock' : 'Low Stock'}
                </Tag>

                <Tag
                  color={item.quantity === 0 ? 'red' : 'volcano'}
                  className={'rounded-full'}
                >
          Qty : {item.quantity}
                </Tag>

              </div>
            </List.Item>
          )}
        />
      )}
    </Modal>
  );
};

FinalProductLowStock.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
  lowStockFinalProducts: PropTypes.array,
  isLoading: PropTypes.bool,
};

export default FinalProductLowStock;
